import React from "react";

export default class StatusFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: {value: 0, label: 'WSZYSTKIE'}
        }

        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filter(event) {
        this.setState({value: event.target.value})
        if (event.target.value === 0) {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }

    }

    isFiltered(targetValue) {
        if (this.refs.statusInput.value === '0') {
            return targetValue
        }
        if (this.refs.statusInput.value === '1') {
            return targetValue === 1
        }
        if (this.refs.statusInput.value === '2') {
            return targetValue === 2
        }
        if (this.refs.statusInput.value === '3') {
            return targetValue === 3
        }
        if (this.refs.statusInput.value === '4') {
            return targetValue === 4
        }
    }

    render() {
        return (
            <div>
                <select ref='statusInput' className='form-control' style={{paddingLeft: 2, fontSize: 12}} value={this.state.value} onChange={this.filter}>
                    <option value="0">WSZYSTKIE</option>
                    <option value="1">ZAPYTANIE</option>
                    <option value="2">REZERWACJA</option>
                    <option value="3">ZAMÓWIENIE</option>
                    <option value="4">WYKONANO</option>
                </select>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/filters/StatusFilter.js